import { useSetAtom } from 'jotai'
import * as R from 'ramda'
import { FC, useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { routeParams } from '../@types/route'
import {
  filterState, // selectedRyoikis,
} from '../atoms/filterState'
import { ClearSelectButton } from '../components/ClearSelectButton'
import { GotoHomeButton } from '../components/GotoHomeButton'
import { NenjiFilter, NenjiFilterHandlers } from '../components/NenjiFilter'
import { RyoikiFilter, RyoikiFilterHandlers } from '../components/RyoikiFilter'
import { RyoikiNenjiLabel } from '../components/RyoikiNenjiLabel'
import { TimeTable } from '../components/TimeTable'

export const RyoikiPage: FC = () => {
  const updateFilter = useSetAtom(filterState)
  const { state }: { state: routeParams | null } = useLocation()
  const { ryoiki, nenji } = useParams()

  const ryoikiFilterRef = useRef({} as RyoikiFilterHandlers)
  const nenjiFilterRef = useRef({} as NenjiFilterHandlers)

  useEffect(() => {
    if (state) {
      // 遷移してきた
      const ryoikiList0 = state.connectedRyoikiIds.split('_')
      const nenjis = state.connectedNenjis.split('').map(s => Number(s))
      // 全体のフィルタを更新
      updateFilter(prev => {
        return {
          ...prev,
          ryoikiIds: ryoikiList0,
          nenjis: nenjis,
        }
      })
    } else {
      // URL変更されてきた
      const lowerRyoikiIds = ryoiki?.split('_') || []
      const upperRyoikiIds = R.map(R.toUpper, lowerRyoikiIds)
      const nenjiList = nenji?.split('') || []
      // 全体のフィルタを更新
      updateFilter(prev => {
        return {
          ...prev,
          ryoikiIds: upperRyoikiIds,
          nenjis: R.map(r => Number(r), nenjiList),
        }
      })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const clearRyoiki = () => {
    // コンポーネントのチェックをクリア
    ryoikiFilterRef.current.reset()
    // 年次はクリアしない
    // nenjiFilterRef.current.reset()

    // 全体のフィルタをクリア
    updateFilter(prev => {
      return {
        ...prev,
        ryoikiIds: [],
        // nenjis: [], // 年次はクリアしない
      }
    })
  }

  return (
    <div className="container mx-auto px-1">
      <GotoHomeButton />

      <div className="py-1">
        <div className="flex flex-row justify-between items-center">
          <h2 className="text-xl font-semibold py-2">
            <RyoikiNenjiLabel />
          </h2>
          <div>
            <ClearSelectButton
              tagId="clearSelectButton"
              onClick={clearRyoiki}
            />
          </div>
        </div>
      </div>

      <div className="py-1">
        <div className="flex flex-row">
          <div className="basis-1/12">
            <p className="text-sm font-midium py-3 px-1">領域：</p>
          </div>
          <div className="basis-11/12">
            <RyoikiFilter ref={ryoikiFilterRef} />
          </div>
        </div>
        <div className="h-[1px] border-b"></div>
        <div className="flex flex-row">
          <div className="basis-1/12">
            <p className="text-sm font-midium py-3 px-1">学年：</p>
          </div>
          <div className="basis-11/12">
            <NenjiFilter ref={nenjiFilterRef} />
          </div>
        </div>
      </div>

      <TimeTable />
    </div>
  )
}
